export default {
    apiUrl: '/api'
  }